// Returns ab test param as { name, value } or null
function getAbTestParam() {
  if (!window.abTestParam) return null;
  const parts = window.abTestParam.split('=');
  return { name: parts[0], value: parts[1] !== undefined ? parts[1] : '1' };
}
// eslint-disable-next-line max-classes-per-file
function animateItemsInViewport() {
  const parentElements = document.querySelectorAll('.animate-parent-in-viewport');

  parentElements.forEach((parentElement) => {
    const items = parentElement.querySelectorAll('.animate-item-in-viewport');

    if (items.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('animate-item');
              observer.unobserve(entry.target);
            }, index * 150);
          }
        });
      },
      { threshold: 0.25 }
    );

    items.forEach((item) => observer.observe(item));
  });
}

class FacetMoreLess extends HTMLElement {
  constructor() {
    super();

    this.clickCount = 0;
    this.filterItems = JSON.parse(this.querySelector('[data-filter-items]').innerHTML);
    this.itemsToFilter = null;

    if (!Object.values(this.filterItems)?.length === 0 || this.filterItems?.filter_values?.length <= 5) {
      this.querySelector('[data-id="more"]').style.display = 'none';

      return;
    }

    let selectedElementList = document.querySelector('.filter-selected-element-list');

    function handleChanges(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (selectedElementList) {
            const activeFiltersElement = selectedElementList.querySelector('[data-active-filters]');
            const clearAllFiltersElement = selectedElementList.querySelector('[data-facet-clear-all]');

            if (activeFiltersElement && selectedElementList.classList.contains('hidden')) {
              selectedElementList.classList.remove('hidden');
              selectedElementList.classList.add('flex');
              if (clearAllFiltersElement) {
                clearAllFiltersElement.removeAttribute('hidden');
              }
            } else if (!activeFiltersElement && selectedElementList.classList.contains('flex')) {
              selectedElementList.classList.add('hidden');
              selectedElementList.classList.remove('flex');
              if (clearAllFiltersElement) {
                clearAllFiltersElement.setAttribute('hidden', '');
              }
            }
          }
        }
      }
    }

    document.addEventListener('collectionGridReady', () => {
      selectedElementList = document.querySelector('.filter-selected-element-list');

      if (selectedElementList) {
        const observer = new MutationObserver(handleChanges);

        observer.observe(selectedElementList, {
          childList: true,
          subtree: true,
        });

        // Call the handleChanges function to process the current state
        handleChanges([{ type: 'childList' }], observer);
      }
    });

    this.addEventListener('click', function handleClick(e) {
      if (e.target.dataset.id === 'more') {
        this.clickCount += 1;
      } else if (e.target.dataset.id === 'less') {
        this.clickCount -= 1;
      }

      if (this.filterItems?.filter_label === 'Color') {
        this.itemsToFilter = this.filterItems.filter_values.map(
          (item, index) => `
          <div class="py-3" data-filter-element>
            <label for="Filter-${item.param_name}--${index + 1}" class="flex items-center">
              <input
                type="checkbox"
                id="Filter-${item.param_name}--${index + 1}"
                class="
                ${
                  theme.collection.enableColorSwatches
                    ? `peer
                  absolute
                  left-0
                  top-0
                  -z-1
                  h-full
                  w-full
                  opacity-0`
                    : `peer
                    form-checkbox
                    mr-2
                    h-6
                    w-6
                    shrink-0
                    border-base-border
                    bg-base-body-background
                    text-base-body
                    rounded-form-element
                    checked:bg-[length:75%_75%]
                    focus:ring-0
                    focus:ring-opacity-0
                    focus:ring-offset-0
                    focus:ring-offset-transparent
                    disabled:bg-base-accent`
                }
                "
                name="${item.param_name}"
                  value="${item.label}"
                ${item.active && 'checked'}
                ${item.count === 0 && item.active === false && 'disabled'}
                >
                ${
                  theme.collection.enableColorSwatches
                    ? `
                <span class="
                  group
                  relative
                  mr-2
                  h-6
                  w-6
                  shrink-0
                  cursor-pointer
                  overflow-hidden
                  rounded-full
                  border
                  border-base-border
                  p-[1px]
                  transition-colors
                  duration-300
                  after:absolute
                  after:left-1/2
                  after:top-1/2
                  after:z-2
                  after:h-full
                  after:w-[1px]
                  after:-translate-x-1/2
                  after:-translate-y-1/2
                  after:rotate-45
                  after:bg-base-overlay-white
                  after:opacity-0
                  after:content-['']
                  peer-checked:border-base-body
                  peer-focus:border-base-body
                  peer-disabled:cursor-default
                  peer-disabled:after:opacity-100
                ">
                  <span
                    style="background-color: ${item.value};"
                    class="block h-full w-full group-[&.rounded-full]:rounded-full"
                  ></span>
                </span>
              `
                    : ''
                }
              <span class="peer-disabled:text-base-secondary">

                ${item.label} (${item.count})
              </span>
            </label>
          </div>
        `
        );
      } else {
        this.itemsToFilter = this.filterItems.filter_values.map(
          (item, index) =>
            `
          <div class="py-3 flex items-center" data-filter-element>
            <input
              type="checkbox"
              id="Filter-${item.param_name}-${index + 1}"
              class="
                peer
                form-checkbox
                relative
                mr-2
                h-6
                w-6
                shrink-0
                overflow-hidden
                rounded-form-element
                border-base-border
                bg-base-body-background
                text-base-body
                after:absolute
                after:left-1/2
                after:top-1/2
                after:h-[150%]
                after:w-[1px]
                after:-translate-x-1/2
                after:-translate-y-1/2
                after:rotate-45
                after:bg-base-border
                after:opacity-0
                after:content-['']
                checked:bg-[length:75%_75%]
                focus:ring-0
                focus:ring-opacity-0
                focus:ring-offset-0
                focus:ring-offset-transparent
                disabled:cursor-default
                disabled:after:opacity-100
            "
              value="${item.value}"
              name="${item.param_name}"
              ${item.active && 'checked'}
              ${item.count === 0 && item.active === false && 'disabled'}
            >
            <label for="Filter-${item.param_name}-${index + 1}" class="w-full peer-disabled:text-base-secondary">
              ${item.label} (${item.count})
            </label>
          </div>
          `
        );
      }

      this.queryVar = this.filterItems?.filter_label === 'Color' ? 'colors' : 'square';

      const filterSlideContainer = this.parentElement.querySelector('[data-filter-slide-container]');

      this.insertAfterEl = filterSlideContainer || this.parentElement;

      if (e.target.dataset.id === 'less') {
        this.items = this.parentElement.querySelectorAll(`[data-filter-element]`);

        this.items.forEach((el, index) => {
          el.remove();
        });

        if (this.clickCount === 0) {
          this.querySelector('[data-id="less"]').style.display = 'none';
          this.querySelector('[data-id="more"]').style.display = 'inline';
        }
      } else if (e.target.dataset.id === 'more') {
        this.insertAfterEl.insertAdjacentHTML('beforeend', this.itemsToFilter.slice(5).join(''));
        this.querySelector('[data-id="more"]').style.display = 'none';
        this.querySelector('[data-id="less"]').style.display = 'inline';
      }
    });
  }

  insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }
}

customElements.define('more-less', FacetMoreLess);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const filterSelectors = document.querySelectorAll('#filter-sortby, #filter-sortby-2, #filter-sortby-3');
    const self = this;
    // Remove the old handler, if there was one
    filterSelectors.forEach((filterSelector) => {
      if (filterSelector._sortbyHandler) {
        filterSelector.removeEventListener('change', filterSelector._sortbyHandler);
      }
      const handler = function (e) {
        const id = this.getAttribute('id');
        let surplusFilter;
        if (id === 'filter-sortby') {
          surplusFilter = document.getElementById('filter-sortby-2') || document.getElementById('filter-sortby-3');
        } else {
          surplusFilter = document.getElementById('filter-sortby');
        }
        const tempValue = surplusFilter.value;
        if (surplusFilter) surplusFilter.value = '';
        const dbSubmit = self.debouncedOnSubmit.bind(self, e);
        dbSubmit().then(() => (surplusFilter.value = tempValue));
      };
      filterSelector.addEventListener('change', handler);
      filterSelector._sortbyHandler = handler;
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');

    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.checkActiveFilters();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((sectionObj) => {
      const url = `${window.location.pathname}?section_id=${sectionObj.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, sectionObj.gridId)
        : FacetFiltersForm.renderSectionFromFetch(url, event, sectionObj.gridId);
    });
    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
    FacetFiltersForm.restoreDetailsState();
  }

  static saveDetailsState() {
    const detailsElements = document.querySelectorAll('#FacetsWrapperDesktop details');

    const detailsState = Array.from(detailsElements).map((details) => ({
      index: details.dataset.index,
      open: details.hasAttribute('open'),
    }));

    localStorage.setItem('detailsState', JSON.stringify(detailsState));
  }

  static restoreDetailsState() {
    let detailsState = [];

    try {
      const storedState = localStorage.getItem('detailsState');

      detailsState = storedState ? JSON.parse(storedState) : [];
    } catch (error) {
      // Error while parsing detailsState from localStorage
      console.error('Failed to parse detailsState from localStorage:', error);
    }

    const facetWrapper = document.querySelector('#FacetsWrapperDesktop');
    if (!facetWrapper) return;
    detailsState.forEach(({ index, open }) => {
      const details = facetWrapper.querySelector(`details[data-index="${index}"]`);
      if (details) {
        if (open) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
      }
    });
  }

  static renderSectionFromFetch(url, event, gridId) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, gridId);
        FacetFiltersForm.renderPagination(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.triggerUpdateQuickViewEvent();
      })
      .then(() => {
        animateItemsInViewport();
        FacetFiltersForm.restoreDetailsState();
      });
  }

  static renderSectionFromCache(filterDataUrl, event, gridId) {
    const { html } = FacetFiltersForm.filterData.find(filterDataUrl);

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, gridId);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.triggerUpdateQuickViewEvent();
    animateItemsInViewport();
    FacetFiltersForm.restoreDetailsState();
  }

  static renderProductGridContainer(html, gridId = 'product-grid') {
    const gridEl = document.getElementById(gridId);
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newGridEl = parsedHTML.getElementById(gridId);
    if (gridEl && newGridEl) {
      gridEl.innerHTML = newGridEl.innerHTML;
    }
    const rerenderedPageEvent = new Event('collectionPageRerender');
    document.dispatchEvent(rerenderedPageEvent);
  }

  static renderPagination(html) {
    const paginationDesktop = document.getElementById('pagination-container-desktop');
    const paginationMobile = document.getElementById('pagination-container-mobile');

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const desktopHTML = parsedHTML.getElementById('pagination-container-desktop');
    const mobileHTML = parsedHTML.getElementById('pagination-container-mobile');

    if (paginationDesktop && desktopHTML) {
      paginationDesktop.innerHTML = desktopHTML.innerHTML;
    }

    if (paginationMobile && mobileHTML) {
      paginationMobile.innerHTML = mobileHTML.innerHTML;
    }

    document.dispatchEvent(new CustomEvent('filterChange'));
  }

  static renderProductCount(html) {
    const updatedContainer = new DOMParser().parseFromString(html, 'text/html');
    const count = updatedContainer.getElementById('ProductCountDesktop').innerHTML;

    const totalProductsCount = updatedContainer.querySelector('[data-total-products-quantity]').dataset
      .totalProductsQuantity;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const productsContainer = document.querySelector('[data-total-products-quantity]');

    if (container) container.innerHTML = count;

    if (containerDesktop) containerDesktop.innerHTML = count;

    productsContainer?.setAttribute('data-total-products-quantity', totalProductsCount);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
      '#FacetFiltersMobile .js-filter'
    );

    const urlParams = new URLSearchParams(window.location.search);

    // Check for parameters containing "filter" in the key
    const hasFilterParam = Array.from(urlParams.keys()).some((key) => key.includes('filter'));

    if (window.innerWidth >= 1024 && !hasFilterParam) {
      facetDetailsElements.forEach((element) => {
        element.setAttribute('open', 'open');
      });
    }

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterSlideContainer = element.querySelector('[data-filter-slide-container]');
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.filter-selected-element-list'];
    const updatedHTML = FacetFiltersForm.toggleActiveFilterDetails(html);

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    // Refresh <input /> values in container of filter adjustments.
    document.querySelector('#FacetsWrapperDesktop').innerHTML =
      updatedHTML.querySelector('#FacetsWrapperDesktop').innerHTML;

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.checkActiveFilters();
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    const productGridDesktop = document.getElementById('product-grid-desktop');
    const productGridSectionId = productGrid?.dataset?.id;
    const productGridSectionIdDesktop = productGridDesktop?.dataset?.id;

    let gridId = null;
    let sectionId = null;
    if (productGridDesktop) {
      gridId = 'product-grid-desktop';
      sectionId = productGridSectionIdDesktop;
    } else if (productGrid) {
      gridId = 'product-grid';
      sectionId = productGridSectionId;
    }

    if (!sectionId) {
      return [];
    }

    return [
      {
        section: sectionId,
        gridId: gridId,
      },
    ];
  }

  static checkActiveFilters() {
    const clearAllBtn = document.querySelector('facet-remove[data-facet-clear-all]');

    const activeFilter = Array.from(document.querySelectorAll('#FacetsWrapperDesktop input')).find((input) => {
      if (input.type === 'number') {
        return input.value.trim().length;
      }

      return input.checked;
    });

    if (activeFilter) {
      FacetFiltersForm.renderClearAll(clearAllBtn);
    } else {
      FacetFiltersForm.hideClearAll(clearAllBtn);
    }
  }

  static renderClearAll(clearAll) {
    clearAll.removeAttribute('hidden');
  }

  static hideClearAll(clearAll) {
    clearAll.setAttribute('hidden', true);
  }

  static triggerUpdateQuickViewEvent() {
    const updateQuickViewEvent = new CustomEvent('updateQuickView');

    document.dispatchEvent(updateQuickViewEvent);
  }

  static toggleActiveFilterDetails(html) {
    const facetWrapper = html.querySelector('#FacetsWrapperDesktop');

    if (!facetWrapper) return html;

    const detailsElements = facetWrapper.querySelectorAll('details');

    detailsElements.forEach((details) => {
      const checkedCheckboxes = details.querySelectorAll('input[type="checkbox"]:checked');

      if (checkedCheckboxes.length > 0) {
        details.setAttribute('open', '');
      }
    });

    return html;
  }

  onSubmitHandler(event) {
    event.preventDefault();

    FacetFiltersForm.saveDetailsState();

    let formData;
    let searchParams;

    if (event?.target?.closest('form')) {
      formData = new FormData(event.target.closest('form'));
      searchParams = new URLSearchParams(formData).toString();
    } else {
      const form = document.getElementById('FacetFiltersForm');

      formData = new FormData(form);
      searchParams = new URLSearchParams(formData).toString();
    }
    // Save the ab test param if it exists
    const abTest = getAbTestParam();
    let params = new URLSearchParams(searchParams);
    if (abTest) {
      params.set(abTest.name, abTest.value);
    }
    // Keep only the first sort_by parameter
    const sortBy = params.get('sort_by');
    params.delete('sort_by');
    if (sortBy) params.set('sort_by', sortBy);
    searchParams = params.toString();

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    let url = '';

    // Get current URL parameters once to avoid duplication
    const currentUrlParams = new URLSearchParams(window.location.search);
    const sortBy = currentUrlParams.get('sort_by');

    const queryStartIndex = event.currentTarget.href.indexOf('?') + 1;
    if (queryStartIndex > 0) {
      const urlParams = new URLSearchParams(event.currentTarget.href.slice(queryStartIndex));

      // If there's sorting in current URL, add it to the new URL
      if (sortBy && !urlParams.has('sort_by')) {
        urlParams.set('sort_by', sortBy);
      }

      // Add ab test param if present
      const abTest = getAbTestParam();
      if (abTest) {
        urlParams.set(abTest.name, abTest.value);
      }

      url = urlParams.toString();
    } else if (sortBy) {
      // If href has no parameters but current URL has sorting, preserve it
      const newParams = new URLSearchParams();

      newParams.set('sort_by', sortBy);

      // Add ab test param if present
      const abTest = getAbTestParam();
      if (abTest) {
        newParams.set(abTest.name, abTest.value);
      }

      url = newParams.toString();
    }

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);

    if (minInput.value) maxInput.setAttribute('min', minInput.value);

    if (minInput.value === '') maxInput.setAttribute('min', 0);

    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;

    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const id = this.querySelector('a').getAttribute('id');

      if (id === 'price-range' || id === 'clear-all') {
        const priceRanges = document.querySelectorAll('.range-slider__input');

        priceRanges.forEach((rangeItem) => {
          rangeItem.value = '';
        });
      }

      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');

  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');

  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;

  return (...args) => {
    clearTimeout(t);

    return new Promise((resolve) => {
      t = setTimeout(() => resolve(fn(...args)), wait);
    });
  };
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function getAbTestParam() {
  if (!window.abTestParam) return null;
  const parts = window.abTestParam.split('=');
  return { name: parts[0], value: parts[1] !== undefined ? parts[1] : '1' };
}
